import * as React from "react";
import { Button, Modal, Input, Form, Radio, message } from "antd";
const FormItem = Form.Item;
const { TextArea } = Input;
// const Option = Select.Option;
const RadioGroup = Radio.Group;

import { connect } from "react-redux";
import { PositionProperty } from "csstype";
import Selector from "widget/selector/other";
import { FormComponentProps } from "antd/lib/form";

interface IAfterSaleProps {
  orderNo: any;
  // // 更新订单标签 批量售后 | 标异常
  updateTags: any;
  // 创建售后单
  saveAfterSale: any;
  getOrderDetails: any;
  id: any;
  type?: any;
  pfn?: any;
}

// 批量售后
class AfterSale extends React.Component<IAfterSaleProps, any> {
  state = {
    visible: false,
    disabled: false,
    isRequest: false,
    contentRef: null
  };

  constructor(props: IAfterSaleProps) {
    super(props);
  }

  showModal = () => {
    if (this.props.orderNo.length > 0) {
      this.setState({
        visible: true
      });
    } else {
      message.config({
        top: 100,
        duration: 2,
        maxCount: 1
      });
      message.warning("请选择订单");
    }
  };

  handleOk = e => {
    const contentRef: any = this.state.contentRef;
    contentRef.getContentFormInfo(e, (res, handle) => {
      if (res.error) {
        return;
      } else {
        this.setState(
          {
            isRequest: true
          },
          () => {
            handle({
              ids: this.props.orderNo.join(),
              ...res.data,
              callback: data => {
                if (data && data.error) {
                  message.error(data.res.msg);
                  this.setState({
                    isRequest: false
                  });
                } else {
                  this.setState({
                    visible: false
                  });
                  // 按钮恢复启用状态
                  this.setState({
                    isRequest: false
                  });
                  const param: any = {
                    id: this.props.id
                  };
                  this.props.getOrderDetails({
                    ...param,
                    callback: () => { }
                  });
                  this.props.pfn();
                  message.success("操作成功");
                }
              }
            });
          }
        );
      }
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
      value: "",
      disabled: false,
      isRequest: false
    });
  };

  onChange = e => {
    const value = e.target.value.trim();
    let disabled = true;
    if (value) {
      disabled = false;
    }

    this.setState({
      value,
      disabled
    });
  };

  updateDisabled = () => {
    return this.state.disabled || this.state.isRequest;
  };

  getContentRef = ref => {
    this.setState({
      contentRef: ref
    });
  };

  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color: "#000",
      border: 'none',
    };
    return (
      <span className={this.props.type ? "after-left" : ''}>
        {!this.props.type ? <Button type="primary" style={buttonStyle} onClick={this.showModal}>售后</Button> : <Button type="primary" onClick={this.showModal}>添加售后单</Button>}
        <Modal
          title="售后"
          visible={this.state.visible}
          destroyOnClose={true}
          keyboard={false}
          centered={true}
          onOk={this.handleOk}
          maskClosable={false}
          okButtonProps={{ disabled: this.updateDisabled() }}
          onCancel={this.handleCancel}
        >
          <Content
            orderNo={this.props.orderNo}
            onRef={this.getContentRef}
            updateTags={this.props.updateTags}
            saveAfterSale={this.props.saveAfterSale}
          />
        </Modal>
      </span>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id
});

const mapDispatch = dispatch => {
  return {
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
    updateTags: dispatch.orderInfo.updateTags,
    saveAfterSale: dispatch.orderInfo.saveAfterSale
  };
};

export default connect(
  mapState,
  mapDispatch
)(AfterSale);

interface IContentProps {
  orderNo: any;
  onRef: any;
  // 标异
  updateTags: any;
  // 创建售后单
  saveAfterSale: any;
}

// 批量售后中的内容
class Content extends React.Component<IContentProps, any> {
  state = {
    type: 0,
    // 标异常对象
    signDiffTagRef: null
  };

  constructor(props: IContentProps) {
    super(props);
    this.props.onRef(this);
  }

  onChange = e => {
    this.setState({
      type: e.target.value
    });
  };

  getContentFormInfo = (e, cb) => {
    if (this.state.type === 0) {
      const ref: any = this.state.signDiffTagRef;
      ref.handleSubmit(e, res => {
        cb(res, this.props.saveAfterSale);
      });
    } else {
      const ref: any = this.state.signDiffTagRef;
      ref.handleSubmit(e, res => {
        cb(res, this.props.updateTags);
      });
    }
  };

  getSignDiffTagRef = ref => {
    this.setState({
      signDiffTagRef: ref,
      createAfterSaleRef: ref
    });
  };

  getCreateAfterSaleRef = ref => {
    this.setState({
      signDiffTagRef: ref,
      createAfterSaleRef: ref
    });
  };

  renderContent = () => {
    if (this.state.type === 0) {
      return (
        <FormCreateAfterSaleForm
          orderNo={this.props.orderNo}
          onRef={this.getCreateAfterSaleRef}
        />
      );
    } else {
      return <FormSignDifferentTag onRef={this.getSignDiffTagRef} />;
    }
  };

  render() {
    return (
      <div>
        <RadioGroup onChange={this.onChange} value={this.state.type} className="select-after">
          <Radio value={0}>创建售后单</Radio>
          <Radio value={1}>标异常</Radio>
        </RadioGroup>
        <div style={{ marginTop: 6 }}>{this.renderContent()}</div>
      </div>
    );
  }
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 }
  }
};

interface ICreateAfterSaleFormProps {
  form: any;
  orderNo: any;
  onRef: any;
}

// 创建售后单
class CreateAfterSaleForm extends React.Component<
  ICreateAfterSaleFormProps,
  any
  > {
  state = {
    reason: "",
    reasonRef: null,
    typeRef: null
  };

  constructor(props: ICreateAfterSaleFormProps) {
    super(props);
    this.props.onRef(this);
  }

  getReasonInfo = () => {
    const ref: any = this.state.reasonRef;
    if (ref && ref.state.value) {
      return ref.state.value;
    } else {
      return null;
    }
  };

  getTypeInfo = () => {
    const ref: any = this.state.typeRef;
    if (ref && ref.state.value) {
      return ref.state.value;
    } else {
      return null;
    }
  };

  handleSubmit = (e: any, cb: any) => {
    e.preventDefault();

    // 设置原因的值
    this.props.form.setFieldsValue({
      reson: this.getReasonInfo(),
      type: this.getTypeInfo()
    });

    this.props.form.validateFields((err, values) => {
      console.log("validateFields", values);
      if (!err) {
        cb({ data: values });
      } else {
        cb({ error: err });
      }
    });
  };

  getReasonRef = ref => {
    this.setState({
      reasonRef: ref
    });
  };

  getTypeRef = ref => {
    this.setState({
      typeRef: ref
    });
  };

  typeChange = value => {
    this.props.form.setFieldsValue({
      type: this.getTypeInfo()
    });
  };

  reasonChange = value => {
    this.props.form.setFieldsValue({
      reson: this.getReasonInfo()
    });
  };

  getFormItem = () => {
    const { getFieldDecorator } = this.props.form;
    const typeRules = {
      rules: [
        {
          required: true,
          message: "请选择售后类型!"
        }
      ]
    };

    const reasonRules = {
      rules: [
        {
          required: true,
          message: "请选择售后原因!"
        }
      ]
    };

    const inputAreaRules = {
      rules: [
        {
          required: false,
          transform: value => {
            return !!value ? value.trim() : null;
          }
        }
      ]
    };

    const type = getFieldDecorator("type", typeRules)(
      <Selector
        selectorName="getAfterSaleType"
        placeholder="请选择售后类型"
        onRef={this.getTypeRef}
        width={300}
        onChange={this.typeChange}
      />
    );

    const reason = getFieldDecorator("reson", reasonRules)(
      <Selector
        selectorName="getAfterSaleReson"
        placeholder="请选择售后原因"
        isMultiple={true}
        width={300}
        onRef={this.getReasonRef}
        onChange={this.reasonChange}
      />
    );

    const spanStyle = {
      position: "absolute" as PositionProperty,
      bottom: 10,
      right: 10,
      lineHeight: "8px",
      color: "#aaa"
    };

    const inputOnChange = e => {
      this.setState({
        reason: e.target.value
      });
    };

    const inputArea = getFieldDecorator("after_desc", inputAreaRules)(
      <div style={{ position: "relative" as PositionProperty, width: 300 }}>
        <TextArea
          placeholder="请输入描述"
          autosize={{ minRows: 6, maxRows: 16 }}
          style={{ width: 300 }}
          maxLength={300}
          onChange={inputOnChange}
        />
        <span style={spanStyle}>
          300/
          {this.state.reason.length}
        </span>
      </div>
    );

    let list: any = [];
    list.push(
      <FormItem key="0" {...formItemLayout} label="售后类型">
        {type}
      </FormItem>
    );

    list.push(
      <FormItem key="1" {...formItemLayout} label="售后原因">
        {reason}
      </FormItem>
    );

    list.push(
      <FormItem key="2" {...formItemLayout} label="描述">
        {inputArea}
      </FormItem>
    );
    return list;
  };

  render() {
    return <Form>{this.getFormItem()}</Form>;
  }
}

const createSaleFormMapDispatch = dispatch => {
  return {
    updateTags: dispatch.orderInfo.updateTags
  };
};

// const FormCreateAfterSaleForm = Form.create()(
//   connect(
//     null,
//     createSaleFormMapDispatch
//   )(CreateAfterSaleForm)
// );

interface formAfterSaleProps extends FormComponentProps {
  orderNo: any,
  onRef: any
}

const FormCreateAfterSaleForm = Form.create<formAfterSaleProps>()(
  connect(
    null,
    createSaleFormMapDispatch
  )(CreateAfterSaleForm)
);

interface ISignDifferentTagProps {
  form: any;
  onRef: any;
}

// 标异常
class SignDifferentTag extends React.Component<ISignDifferentTagProps, any> {
  constructor(props: ISignDifferentTagProps) {
    super(props);
    this.props.onRef(this);
  }

  getFormItem = () => {
    const { getFieldDecorator } = this.props.form;
    const inputAreaRules = {
      rules: [
        {
          required: true,
          whitespace: true,
          transform: value => {
            return !!value ? value.trim() : null;
          },
          message: "请输入异常原因!"
        }
      ]
    };



    const inputArea = getFieldDecorator("remark", inputAreaRules)(
      <div style={{ position: "relative" as PositionProperty, width: 300 }}>
        <TextArea
          placeholder="请输入异常原因"
          autosize={{ minRows: 6, maxRows: 16 }}
          style={{ width: 300 }}
          maxLength={300}
        />

      </div>
    );

    let list: any = [];
    list.push(
      <FormItem key="0"  {...formItemLayout} label="异常原因">
        {inputArea}
      </FormItem>
    );

    return list;
  };

  handleSubmit = (e: any, cb: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        cb({ data: values });
      } else {
        cb({ error: err });
      }
    });
  };
  render() {
    return <Form>{this.getFormItem()}</Form>;
  }
}

interface formSignDiffTagProps extends FormComponentProps {
  onRef: any
}
const FormSignDifferentTag = Form.create<formSignDiffTagProps>()(SignDifferentTag);
